import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { fetchIssueAgenda, fetchTitleAgenda, fetchTitleAgendaHistory, } from "../api/agendaService";
import { ISSUE_AGENDA_KEY, TITLE_AGENDA_HISTORY_KEY, TITLE_AGENDA_KEY, } from "../utils/agendaQueries";
import { retryUnlessClientError } from "../utils/apiUtils";
export var useTitleAgenda = function (titleId) {
    var kyInstance = useOkapiKy();
    return useQuery([TITLE_AGENDA_KEY, titleId], function () { return fetchTitleAgenda(kyInstance, titleId); }, { enabled: !!titleId, retry: retryUnlessClientError });
};
export var useIssueAgenda = function (issueId) {
    var kyInstance = useOkapiKy();
    return useQuery([ISSUE_AGENDA_KEY, issueId], function () { return fetchIssueAgenda(kyInstance, issueId); }, { enabled: !!issueId, retry: retryUnlessClientError });
};
export var useTitleAgendaHistory = function (titleId) {
    var kyInstance = useOkapiKy();
    return useQuery([TITLE_AGENDA_HISTORY_KEY, titleId], function () { return fetchTitleAgendaHistory(kyInstance, titleId); }, { enabled: !!titleId, retry: retryUnlessClientError });
};
